import React from "react";
import UploadedDocsComponent from "../../../components/cases/uploadedDocuments/UploadedDocs";

const AdvisorUploadedDocs = () => {
  return (
    <div>
      <UploadedDocsComponent />
    </div>
  );
};

export default AdvisorUploadedDocs;
